import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../app/funcs/orderResultToast";
import { getUtilizationDocuments, uploadUtilizationDocument, deleteUtilizationDocument } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/UtilizationDocument",
    getList: "getList",
    uploadFile: "uploadFile",
    delete: "delete",
});

export const getUtilizationDocumentsAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async (_, { rejectWithValue }) => {
        const response = await getUtilizationDocuments();

        if (response.error === undefined) {
            return { ...response };
        } else {
            return rejectWithValue({});
        }
    }
);

export const uploadUtilizationDocumentAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.uploadFile}`,
    async (data: { acceptedFile: any, onSuccess: () => void }, { rejectWithValue }) => {
        const { acceptedFile, onSuccess } = data;
        const response = await uploadUtilizationDocument(acceptedFile);

        if (response.ok) {
            orderSuccessToast("ファイルをアップロードしました");
            onSuccess();
            return { ...response };
        } else {
            orderErrorToast("ファイルのアップロードに失敗しました");
            return rejectWithValue({});
        }
    }
);

export const deleteUtiliztiondocumentAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.delete}`,
    async (data: { objectName: string, onSuccess: () => void }, { rejectWithValue }) => {
        const { objectName, onSuccess } = data;
        const response = await deleteUtilizationDocument(objectName);

        if (response.error === undefined) {
            orderSuccessToast("ファイルを削除しました");
            onSuccess();
            return { ...response };
        } else {
            orderErrorToast("ファイルの削除に失敗しました");
            return rejectWithValue({});
        }
    }
);
